import type React from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useUrlSearch } from '@/hooks'

const Redirect: React.FC = () => {
  const history = useHistory()
  const query = useUrlSearch<{ href?: string; uri?: string }>()
  const { href, uri } = query || {}

  useEffect(() => {
    if (typeof href === 'string') {
      const target = decodeURIComponent(href)
      if (/^https?:\/\//.test(target)) {
        window.location.href = target
      }
    }
  }, [href])

  useEffect(() => {
    if (typeof uri === 'string') {
      const target = decodeURIComponent(uri)
      history.replace(target)
    }
  }, [uri, history])

  return null
}

Redirect.displayName = 'Redirect'

export default Redirect
